import axiosInstance from "./AxiosConfig";
import {REST_API_BASE_URL_REMOTE} from '../services/PathEnvironment'
import { cleanParams } from "./PostService";

const REST_API_BASE_URL = REST_API_BASE_URL_REMOTE + 'api/seekingposts';

const enc = (value) => encodeURIComponent(String(value ?? '').trim());

export const listSeekingPosts = (page, size, sort) => axiosInstance.get(REST_API_BASE_URL, { params: { page, size, sort: `${sort},desc` } });

export const listYourSeekingPosts = (userId, page, size, sort) => axiosInstance.get(REST_API_BASE_URL + '/user/' + userId, { params: { page, size, sort: `${sort},desc` } });

export const createSeekingPost = (seekingPost) => axiosInstance.post(REST_API_BASE_URL, seekingPost);

export const getSeekingPost = (seekingPostId) => axiosInstance.get(REST_API_BASE_URL + '/seekingpost/' + seekingPostId);

export const updateSeekingPost = (seekingPostId, seekingPost) => axiosInstance.put(REST_API_BASE_URL + '/' + seekingPostId, seekingPost);

export const deleteSeekingPost = (seekingPostId) => axiosInstance.delete(REST_API_BASE_URL + '/' + seekingPostId);

export const removeAllYourSeekingPosts = (userId) => axiosInstance.delete(REST_API_BASE_URL + '/all/' + userId);

export const listFilterSeekingPosts = (key, page, size, withDescription, sort, ascDesc) => axiosInstance.get(REST_API_BASE_URL + '/' + enc(key), { params: { page, size, withDescription: Boolean(withDescription), sort: `${sort},${ascDesc}` } });

export const searchSeekingPostsAdvanced = (filters, page, size, sort, direction) => axiosInstance.get(REST_API_BASE_URL + '/search/advanced', { params: { ...cleanParams(filters), page, size, sort: `${sort},${direction}` } });

export const listUserFilterSeekingPosts = (key, userId, page, size,sort, ascDesc) => axiosInstance.get(REST_API_BASE_URL + '/user/' + enc(key) + "/" + userId, { params: { page, size, sort: `${sort},${ascDesc}` } });

export const addSeekingUserView = (postId) => axiosInstance.post(REST_API_BASE_URL + '/user/view/' + postId);

export const increaseSeekingJobSubmission = (postId) => axiosInstance.post(REST_API_BASE_URL + '/' + postId + '/submissions');
